module.exports = __webpack_public_path__ + "img/default-avatar.cab6efb4.png";